import React from "react";
import { Link } from "react-router-dom";
import { useParams, Navigate } from "react-router-dom";
import { Layout } from "../components/tag/Layout";
import { HeroBg, EyebrowPill } from "../components/tag/Primitives";
import { POLICIES, EFFECTIVE_DATE, COMPANY, POLICY_GROUPS } from "../data/legal";

export default function LegalPage() {
  const { slug } = useParams();
  const policy = POLICIES[slug];

  if (!policy) return <Navigate to="/" replace />;

  return (
    <Layout title={`${policy.title} | ${COMPANY}`} path={`/legal/${slug}`}>
      {/* HERO */}
      <section
        data-testid={`legal-hero-${slug}`}
        style={{
          background: "#090909",
          padding: "60px 32px 36px",
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
        }}
      >
        <HeroBg />
        <div style={{ position: "relative", zIndex: 1, maxWidth: 760, margin: "0 auto" }}>
          <div style={{ marginBottom: 22 }}>
            <EyebrowPill>{policy.eyebrow}</EyebrowPill>
          </div>
          <h1 className="tag-h1" style={{ marginBottom: 14, fontSize: 36 }}>
            {policy.title}
          </h1>
          <p style={{ color: "#777", fontSize: 12, letterSpacing: "0.06em", textTransform: "uppercase" }}>
            Effective {EFFECTIVE_DATE}
          </p>
        </div>
      </section>

      {/* CONTENT */}
      <section style={{ background: "#090909", borderTop: "1px solid #1a1a1a", padding: "44px 20px 56px" }}>
        <div className="legal-grid" style={{ maxWidth: 1100, margin: "0 auto", display: "grid", gridTemplateColumns: "240px 1fr", gap: 40, alignItems: "start" }}>
          {/* Sidebar — sibling legal links */}
          <aside data-testid="legal-sidebar" className="legal-sidebar" style={{ position: "sticky", top: 80 }}>
            {POLICY_GROUPS.map((group) => (
              <div key={group.label} style={{ marginBottom: 22 }}>
                <div style={{ color: "#888", fontSize: 9, fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 10 }}>
                  {group.label}
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
                  {group.items.map((s) => {
                    const p = POLICIES[s];
                    if (!p) return null;
                    const active = s === slug;
                    return (
                      <Link
                        key={s}
                        to={`/legal/${s}`}
                        data-testid={`legal-link-${s}`}
                        style={{
                          color: active ? "#fff" : "#888",
                          fontSize: 12,
                          fontWeight: active ? 600 : 500,
                          paddingLeft: active ? 8 : 0,
                          borderLeft: active ? "2px solid #FF6575" : "2px solid transparent",
                          lineHeight: 1.4,
                          transition: "color 0.15s ease",
                        }}
                      >
                        {p.title}
                      </Link>
                    );
                  })}
                </div>
              </div>
            ))}
          </aside>

          {/* Article */}
          <article data-testid="legal-article" className="tag-card" style={{ padding: 36 }}>
            {policy.intro && (
              <p style={{ color: "#bbb", fontSize: 14, lineHeight: 1.75, marginTop: 0, marginBottom: 28 }}>
                {policy.intro}
              </p>
            )}
            {policy.sections.map((s, i) => (
              <section key={i} style={{ marginBottom: 28 }}>
                <h2 style={{ color: "#fff", fontSize: 16, fontWeight: 700, margin: "0 0 12px", letterSpacing: "-0.01em" }}>
                  {s.h}
                </h2>
                {s.p.map((para, j) => (
                  <p key={j} style={{ color: "#bbb", fontSize: 13, lineHeight: 1.75, margin: "0 0 10px" }}>
                    {para}
                  </p>
                ))}
              </section>
            ))}
            <div style={{ borderTop: "1px solid #1a1a1a", paddingTop: 18, color: "#555", fontSize: 11 }}>
              {COMPANY} — Effective {EFFECTIVE_DATE}.
            </div>
          </article>
        </div>
        <style>{`
          @media (max-width: 880px) {
            .legal-grid { grid-template-columns: 1fr !important; }
            .legal-sidebar { position: static !important; }
          }
        `}</style>
      </section>
    </Layout>
  );
}
